import api from "@/helpers/api_helper";
import qs from 'qs';

export type OrderCustomer = {
    id: string,
    realName: string,
    email: string,
    phoneNumber: string,
    smsMarketingConsented: boolean,
    emailMarketingConsented: boolean,
    userType: '회원' | '비회원' | string,
    totalOrderAmount: number,
    mileageDeposit: number,
}

export const getCustomerList = async (mallId: string, queryParams?: {
    offset: number, limit: number
}): Promise<{
    list: OrderCustomer[],
    total: number;
}> => {

    try {
        const offset = queryParams?.offset || 0;
        const limit = queryParams?.limit || 15;
        queryParams = {
            offset: offset,
            limit: limit,
            ...queryParams,
        }
        const queryStr = qs.stringify(queryParams);
        return await api.get(`/mall/${mallId}/order-customer?${queryStr}`).then(r => {
            return {
                list: r.data?.orderCustomerList || r.data?.list || [],
                total: Number(r?.data?.total || r?.data?.totalCount || 0)
            };
        })
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e;
        }
    }
}

export type InquiryReplyItem = {
    messageOrder: number,
    body: string,
    attachedFileUrl: string[],
    isInquirer: boolean,
    createdAt: string,
}

export type InquiryItem = {
    id: string,
    title: string,
    inquiryKind: string,
    inquirerMallUserName: string,
    inquiryState?: '미답변' | '답변완료' | string,
    body: string,
    attachedFileUrl?: string[],
    createdAt: string,
    inquiryReplyCount: number,
    inquiryReplyInfo: InquiryReplyItem[]
}
export const getInquiryList = async (mallId:string):Promise<{
    list: InquiryItem[],
}> => {
    try {
        return await api.get(`/mall/${mallId}/inquiry`).then(r => {
            return {
                list: r.data?.inquiryList || [],
            };
        })
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e;
        }
    }
}

export type InquiryReplyRequestBody = {
    body: string,
    attachedFileUrl?: string[],
}
export const postInquiryReply = async (mallId:string, inquiryId:string, data:InquiryReplyRequestBody) => {
    try {
        return await api.post(`/mall/${mallId}/inquiry/${inquiryId}/reply`, data).then(r => {
            return r.data || {};
        })
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e;
        }
    }
}